import { render, staticRenderFns } from "./oversold_list.vue?vue&type=template&id=0a4bfd59&scoped=true"
import script from "./oversold_list.vue?vue&type=script&lang=js"
export * from "./oversold_list.vue?vue&type=script&lang=js"
import style0 from "./oversold_list.vue?vue&type=style&index=0&id=0a4bfd59&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bfd59",
  null
  
)

export default component.exports